<section id="manage-data-page">
  <div class="manage-data-page-title">
    <h3>{{'MANAGE-DATA.TEXT' | translate}}</h3>
  </div>
  <div class="manage-data-content">
    <div id="login" class="pb-5 pt-0">
      <div class="login p-0">
        <form *ngIf="!sendDeleted" [formGroup]="manageDataForm" (ngSubmit)="submitForm()"
          class="login-form pb-5 pt-2 text-center">
          <div class="form-group">
            <div class="logo-entity mb-3 text-center">
              <span *ngIf="form['type'].value == 1">{{'t-manage-data-text' | translate}}</span>
              <span *ngIf="form['type'].value == 2">{{'t-manage-data-delete-text' | translate}}</span>
            </div>
          </div>
          <div class="form-group mb-4">
            <!-- <label class="w-100 text-center">{{'t-email' | translate}}</label> -->
            <ng-select [clearable]="false" [searchable]="false" placeholder="{{'t-solicitation' | translate}}"
              formControlName="type" [ngClass]="{
                            'is-invalid': submited && form['type'].errors
                          }" name="type" id="type">
              <ng-option *ngFor="let item of selectData" value="{{item.id}}">{{item.label |
                translate}}</ng-option></ng-select>
            <div *ngIf="submited && form['type'].errors" class="invalid-feedback">
              <div *ngIf="form['type'].errors['required']">
                {{'t-validation-solicitation' | translate}}
              </div>
            </div>
            <i class="icon_mail_alt"></i>
          </div>
          <div class="form-group mb-4">
            <label class="w-100 text-center">{{'t-manage-data-confirm-email' | translate}}</label>
            <input type="email" placeholder="{{'t-email' | translate}}" formControlName="email" [ngClass]="{
                            'is-invalid': submited && form['email'].errors
                          }" class="form-control" name="email" id="email">
            <div *ngIf="submited && form['email'].errors" class="invalid-feedback">
              <div *ngIf="form['email'].errors['required']">
                {{'t-validation-email' | translate}}
              </div>
              <div *ngIf="form['email'].errors['email']">
                {{'t-validation-email-2' | translate}}
              </div>
              <div *ngIf="form['email'].errors['noData']">
                {{'t-manage-data-no-info' | translate}}
              </div>
            </div>
            <i class="icon_mail_alt"></i>
          </div>
          <div *ngIf="showDataMessage && form['type'].value == 1" class="form-group mb-4">
            <span class="text-center">{{'t-manage-data-instructions' | translate}}</span>
          </div>
          <button class="btn white w-50 submit-button" type="submit" [attr.disabled]="isDisabled ? '' : null">
            <span *ngIf="!isDisabled">{{'t-continue' | translate}}</span>
            <span class="d-flex justify-content-center" *ngIf="isDisabled">
              <span class="me-2">
                {{'t-continue' | translate}}...
              </span>
              <span class="spinner-border flex-shrink-0" role="status">
                <span class="visually-hidden">{{'t-continue' | translate}}...</span>
              </span>
            </span>
          </button>
        </form>
        <form *ngIf="sendDeleted" [formGroup]="codeDeletedForm" (ngSubmit)="submitDelete()"
          class="login-form pb-5 pt-2 text-center">
          <div class="form-group">
            <div class="logo-entity mb-3 text-center">
              <span>{{'t-manage-data-delete' | translate}}</span>
            </div>
          </div>
          <div class="form-group mb-4">
            <!-- <label class="w-100 text-center">Insira o código enviado ao seu e-mail</label> -->
            <input type="text" placeholder="{{'t-code' | translate}}" formControlName="code" [ngClass]="{
                            'is-invalid': submited && formDelete['code'].errors
                          }" class="form-control" name="code" id="code">
            <div *ngIf="submited && formDelete['code'].errors" class="invalid-feedback">
              <div *ngIf="formDelete['code'].errors['required']">
                {{'t-validation-code' | translate}}
              </div>
              <div *ngIf="formDelete['code'].errors['wrongCode']">
                {{'t-code-validation-error' | translate}}
              </div>
              <div *ngIf="formDelete['code'].errors['noData']">
                {{'t-manage-data-no-info' | translate}}
              </div>
            </div>
            <i class="icon_mail_alt"></i>
          </div>
          <div *ngIf="showDeletedMessage" class="form-group deleted-message mb-4">
            <!-- <label class="w-100 text-center">{{'t-email' | translate}}</label> -->
            <span class="text-center">{{'t-manage-data-deleted' | translate}}</span>
          </div>
          <button class="btn white w-50 submit-button" type="submit" [attr.disabled]="isDisabled ? '' : null">
            <span *ngIf="!isDisabled">{{'t-delete' | translate}}</span>
            <span class="d-flex justify-content-center" *ngIf="isDisabled">
              <span class="me-2">
                {{'t-delete' | translate}}...
              </span>
              <span class="spinner-border flex-shrink-0" role="status">
                <span class="visually-hidden">{{'t-delete' | translate}}...</span>
              </span>
            </span>
          </button>
        </form>
        <!-- <span>{{'t-manage-data-contact' | translate}}
                </span> -->
      </div>
    </div>
  </div>
</section>
